import mapper from '../internal/Mapper';
export class UserProperty {
    constructor(key, value) {
        this.key = key;
        this.value = value;
        this.definedKey = mapper.convertDefinedUserPropertyKey(key);
    }
}
//# sourceMappingURL=UserProperty.js.map